import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo_Phoi.png'


const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = {
  class: "p-field p-col-12 p-md-12",
  style: {"background":"gray"}
}
const _hoisted_10 = { style: {"width":"65%","margin":"auto"} }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_18 = { style: {"color":"blue"} }
const _hoisted_19 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_20 = { style: {"color":"red"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  id: "scroll-container"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "scroll-text",
    style: {"align-items":"center","width":"150%"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "background",
      src: _imports_0,
      style: {"width":"40px","height":"40px"}
    }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("label", { style: {"color":"#3e9cba","font-size":"20px"} }, " BỆNH VIỆN PHỔI THÀNH PHỐ ĐÀ NẴNG ")
  ])
], -1)
const _hoisted_22 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_23 = { id: "loading" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Hệ thống đang xử lý, vui lòng chờ trong giây lát ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_camera = _resolveComponent("camera")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Panel, {
          header: "Hệ thống Checkin/Checkout Bệnh viện Phổi Đà Nẵng",
          style: {"padding-bottom":"-10px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_camera, {
                            resolution: { width: 480, height: 270 },
                            facingMode: { exact: _ctx.user },
                            ref: "camera",
                            onError: $setup.error
                          }, null, 8, ["facingMode", "onError"]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_Button, {
                                  onClick: $setup.snapshotCheckIn,
                                  label: "CHECKIN",
                                  icon: "pi pi-map-marker",
                                  style: {"font-weight":"bold"},
                                  severity: "success",
                                  raised: ""
                                }, null, 8, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_Button, {
                                  onClick: $setup.snapshotCheckOut,
                                  label: "CHECKOUT",
                                  icon: "pi pi-map-marker",
                                  style: {"font-weight":"bold"},
                                  severity: "warning",
                                  raised: ""
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Dialog, {
          visible: $setup.checkin,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkin) = $event)),
          style: { width: '90vw'},
          breakpoints: { '1500px': '70vw', '1150px': '80vw' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Thông báo Checkin/Checkout" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  ($setup.checkinResponse.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString($setup.checkinResponse.log), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString($setup.checkinResponse.log), 1)
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_Dialog, {
          header: "Hệ thống Checkin/Checkout",
          visible: $setup.loadingBar,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (($setup.loadingBar) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                style: {"height":".3em"}
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_ConfirmDialog)
      ])
    ])
  ]))
}